import { push } from 'react-router-redux';
import store from '../store';

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable(); // eslint-disable-line
  window.Promise = require('promise/lib/es6-extensions.js'); // eslint-disable-line
}

// fetch() polyfill for making API calls.
require('whatwg-fetch');

const originalFetch = window.fetch;
window.fetch = (url, options = {}) => {
  if (options.useNative) {
    return originalFetch(url, options);
  }
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    ...options.headers,
  };
  options.headers = headers;
  if (options.body) {
    options.body = JSON.stringify(options.body);
  }
  return originalFetch(url, options).then(r =>
    r.json().then(result => {
      if (r.status === 401) {
        return store.dispatch(push('/login'));
      }
      if (r.status !== 200) throw result;
      return result;
    }),
  );
};

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign');

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (process.env.NODE_ENV === 'test') {
  require('raf').polyfill(global); // eslint-disable-line
}
